var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconIllustrationHandCoins(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 80 80",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37 60h-2c0-2.206 1.794-4 4-4h11c1.103 0 2-.897 2-2s-.897-2-2-2h-9.176l-11-4H21v-2h9.176l11 4H50c2.206 0 4 1.794 4 4s-1.794 4-4 4H39c-1.103 0-2 .897-2 2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.245 70h-2.416l-17-6H22v-2h4.171l17 6h1.584l24.631-12.808C69.66 54.878 70 54.35 70 54a2.002 2.002 0 00-1.862-1.995l-15.84 4.949-.596-1.908L68 50c2.206 0 4 1.794 4 4 0 1.371-1.16 2.573-1.292 2.706l-.247.182L45.245 70",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53 36c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 10c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6zM37 28c-2.206 0-4 1.794-4 4s1.794 4 4 4 4-1.794 4-4-1.794-4-4-4zm0 10c-3.309 0-6-2.691-6-6s2.691-6 6-6 6 2.691 6 6-2.691 6-6 6z",
    fill: "#E97025",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A5ADB1",
    d: "M16 62h2v-2h-2zM12 62h2v-2h-2z",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E97025",
    d: "M38 18h2v-8h-2zM34 24h2v-8h-2zM38 22h2v-2h-2zM34 14h2v-2h-2zM50 26h2v-8h-2zM54 32h2v-8h-2zM50 30h2v-2h-2zM54 22h2v-2h-2z",
    className: "fi-icon-illustrative-highlight-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 66H8v-2h12V46H8v-2h12c1.103 0 2 .897 2 2v18c0 1.103-.897 2-2 2",
    fill: "#A5ADB1",
    className: "fi-icon-illustrative-base-fill"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 0h80v80H0z"
  }))));
}

export default SvgIconIllustrationHandCoins;